// extracted by mini-css-extract-plugin
export default {"container":"style_container__DfM4G","containerInput":"style_containerInput__IQRGN","clip":"style_clip__K+2q8","input":"style_input__VOkrk","uploader":"style_uploader__HUAq2"};